export default __webpack_public_path__ + "static/media/ebe2dc667274ed4250e98e90c98d9642.png";